import { useEffect, useState } from "react";
import { useLenis } from "lenis/react";

const getFixedElements = (): HTMLElement[] =>
  Array.from(document.querySelectorAll<HTMLElement>("*")).filter(
    (el) => getComputedStyle(el).position === "fixed",
  );

const useScrollLock = (isLocked: boolean) => {
  const [locked, toggleLock] = useState(isLocked);
  const lenis = useLenis();

  useEffect(() => {
    if (lenis) {
      if (locked) {
        const scrollBarWidth = getComputedStyle(document.documentElement)
          .getPropertyValue("--scrollbar-width")
          .trim();
        if (scrollBarWidth && scrollBarWidth !== "0px") {
          getFixedElements().forEach((el) => {
            el.style.paddingRight = `var(--scrollbar-width)`;
            el.style.marginRight = `var(--scrollbar-width)`;
          });
        }
        lenis?.stop();
      } else {
        getFixedElements().forEach((el) => {
          el.style.paddingRight = `unset`;
          el.style.marginRight = `unset`;
        });
        lenis?.start();
      }
    }

    return () => {
      document.body.style.paddingRight = `unset`;
      getFixedElements().forEach((el) => {
        el.style.paddingRight = `unset`;
        el.style.marginRight = `unset`;
      });
      lenis?.start();
    };
  }, [locked, lenis]);

  return { toggleLock };
};

export default useScrollLock;
